var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 8.70834C8.42804 8.70834 7.85661 8.48782 7.42357 8.05479L0.903573 1.53479C0.808835 1.44005 0.808835 1.27663 0.903573 1.18189C0.998311 1.08716 1.16173 1.08716 1.25647 1.18189L7.77647 7.70189C8.45173 8.37715 9.54831 8.37716 10.2236 7.70189L16.7436 1.18189C16.8383 1.08716 17.0017 1.08716 17.0965 1.18189C17.1912 1.27663 17.1912 1.44005 17.0965 1.53479L17.45 1.88834L17.0965 1.53479L10.5765 8.05479C10.1434 8.48782 9.572 8.70834 9.00002 8.70834Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.437e25450dd31e1def691397a7c5041d.svg";
export { ForwardRef as ReactComponent };